@if (showContent && !isPreview && !isLoginPage) {
<div
  class="container-new"
  [class.white-background]="isEmbeddedView"
  [class.embedded-shell]="isEmbeddedView"
>
  @if (!isEmbeddedView) {
  <div class="default-sidebar">
    <!-- Here goes side-nav -->
    <app-side-navbar></app-side-navbar>
  </div>
  }
  <div class="right">
    @if (!isEmbeddedView) {
    <app-header></app-header>
    }
    <div #embeddedViews class="views" [class.views--embedded]="isEmbeddedView">
      <!-- Here goes views -->
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
} @if (isPreview) {
<router-outlet></router-outlet>
} @if (isLoginPage) {
<router-outlet></router-outlet>
}
<app-loader></app-loader>
